import { Box, Chip } from "@mui/material";

/**
 * FilterChipBar — Design Gap Audit item G.2/H.2 reusable component.
 *
 * Matches the prototype's inline filter-chip style (e.g. "+ Age",
 * "+ Skills") for a bounded set of toggle-able options, replacing a
 * dropdown `<Select>` for filters where the option count is small and
 * fixed (e.g. candidate status) — NOT intended for large/dynamic
 * picklists (job codes, recruiters, companies), where a dropdown remains
 * the better UX and is intentionally left unchanged elsewhere.
 *
 * Purely presentational: the calling page owns the actual filter state
 * and predicate logic; this component only renders chips and reports
 * clicks.
 *
 * Props:
 *   options    - array of { key, label } (required)
 *   selected   - array of currently-selected keys (required)
 *   onToggle   - (key) => void, called when a chip is clicked (required)
 */
export default function FilterChipBar({ options, selected, onToggle }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {options.map((opt) => {
        const isActive = selected.includes(opt.key);
        return (
          <Chip
            key={opt.key}
            label={opt.label}
            size="small"
            onClick={() => onToggle(opt.key)}
            variant={isActive ? "filled" : "outlined"}
            color={isActive ? "primary" : "default"}
            sx={{ fontWeight: 600, fontSize: 12.5 }}
          />
        );
      })}
    </Box>
  );
}
